import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export function TickerStrip({ t }) {
  if (!t?.enabled || t.live === false || !t.text?.trim()) return null;
  const font = t.digital ? "'Orbitron', monospace" : "inherit";
  const glow = t.digital ? `0 0 6px ${t.color}aa` : "none";
  const items = [0, 1, 2, 3];
  return (
    <div data-testid="text-ticker" className="mx-3 mt-3 overflow-hidden rounded-full border-[3px] select-none"
      style={{ background: t.bg, borderColor: t.border }}>
      <div className="gs-marquee flex w-max py-2" style={{ animationDuration: `${t.speed}s` }}>
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
            {items.map((i) => (
              <span key={i} data-testid={k === 0 && i === 0 ? "text-ticker-text" : undefined} className="whitespace-nowrap font-bold px-6"
                style={{ color: t.color, fontFamily: font, fontSize: `${t.size}px`, letterSpacing: t.digital ? "0.08em" : undefined, textShadow: glow }}>
                {t.text}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function TextTicker() {
  const [t, setT] = useState(null);
  useEffect(() => {
    api.get("/ticker").then((r) => setT(r.data)).catch(() => {});
  }, []);
  return <TickerStrip t={t} />;
}

export default TextTicker;
